import { SettingsMap } from '../dashboardSettingsTypes';

export const SETTINGS_MAP = {
  keyMetricsCapital: {
    label: 'Key Metrics Capital',
    components: {
      committedCapital: {
        label: 'Committed Capital',
        fieldName: 'totalCommittedCapital',
        fieldType: 'currency0',
        tooltip: 'Sum of LP Commitments to the funds',
      },
      capitalCalled: {
        label: 'Capital Called',
        fieldName: 'capitalCalled',
        fieldType: 'currency0',
        tooltip: 'Sum of all LP Wires into the fund',
      },
      investedCapital: {
        label: 'Invested Capital',
        fieldName: 'investedCapital',
        fieldType: 'currency0',
        tooltip: 'Sum of Investments made by the fund in its portfolio companies',
      },
      companiesNumber: {
        label: 'No. Of Companies',
        fieldName: 'companiesCount',
        fieldType: 'integer',
      },
      realizedValue: {
        label: 'Realized Value',
        fieldName: 'realizedValue',
        fieldType: 'currency0',
      },
      bookValue: {
        label: 'Book Value',
        fieldName: 'bookValue',
        fieldType: 'currency0',
        tooltip: 'Sum of NAVs from the fund’s investment in the companies as of end of quarter date',
      },
    }
  },
  keyMetricsGrossAndNet: {
    label: 'Key Metrics Gross And Net',
    components: {
      grossMultiple: {
        label: 'Gross Multiple',
        fieldName: 'grossMultiple',
        fieldType: 'ratio2',
        tooltip: 'Takes the sum of the unrealized and realized values and dividing by the sum of the total fund Invested Capital',
      },
      grossRealizedMultiple: {
        label: 'Net Multiple',
        fieldName: 'grossRealizedMultiple',
        fieldType: 'ratio2',
        tooltip: 'Determined by dividing the Realized Value by the Invested Capital',
      },
      netTVPI: {
        label: 'Net TVPI',
        fieldName: 'netTvpi',
        fieldType: 'ratio2',
        tooltip: 'Total Gain of value',
      },
      RVPI: {
        label: 'RVPI',
        fieldName: 'rvpi',
        fieldType: 'ratio2',
        tooltip: 'Residual Value to Paid in Capital- if GP Carried Interest:  "kicks in" (A), not "kicked in" (B)',
      },
      DPI: {
        label: 'DPI',
        fieldName: 'dpi',
        fieldType: 'ratio2',
        tooltip: 'The sum of LP Distributions divided by the Capital Called',
      },
      grossIRR: {
        label: 'Gross IRR',
        fieldName: 'grossIrr',
        fieldType: '100percentage2',
        tooltip: 'XIRR calculation which accounts for portfolio company investments as outflows and the Book Value as an inflow',
      },
      netIRR: {
        label: 'Net IRR',
        fieldName: 'netIrr',
        fieldType: '100percentage2',
        tooltip: 'XIRR calculation which accounts for LP wires into the fund as outflows, and both (1) LP distributions; and (2) unrealized value left for LPs, after account for GP carried interest',
      },
    }
  },
  fundPerformance: {
    label: 'Fund Performance',
    components: {
      investmentBySector: {
        label: 'Investment By Sector',
        fieldName: 'investmentBySector',
        fieldType: '',
      },
      netIRR: {
        label: 'Net IRR',
        fieldName: 'netIRR',
        fieldType: '',
      },
    }
  },
  subFundsPortfolio: {
    label: 'Sub Funds Portfolio',
    components: {
      investedCapital: {
        label: 'Invested Capital',
        fieldName: 'investedCapital',
        fieldType: 'currency0',
        tooltip: '',
      },
      realizedValue: {
        label: 'Realized Value',
        fieldName: 'realizedValue',
        fieldType: 'currency0',
        tooltip: 'The fund’s fully diluted ownership percentage of the portfolio company',
      },
      FD: {
        label: 'FD%',
        fieldName: 'ownershipPercent',
        fieldType: 'percentage2',
        tooltip: '',
      },
      NAV: {
        label: 'NAV',
        fieldName: 'nav',
        fieldType: 'currency0',
        tooltip: 'NAV is determined by EE Invest based on the Waterfall output of the fund’s investment in the portfolio company; taking into account liquidation preferences, anti dilution provisions and similar investments and terms of co-investors',
      },
      EV: {
        label: 'EV',
        fieldName: 'ev',
        fieldType: 'currency0',
        tooltip: 'EV is determined by the PPS of the latest financing round multiplied by the # of fully diluted shares in the cap table',
      },
      multiple: {
        label: 'Multiple',
        fieldName: 'multiple',
        fieldType: 'ratio2',
        tooltip: 'NAV and Realized Value in the portfolio company, divided by the Invested Capital in the company',
      },
      IRR: {
        label: 'IRR',
        fieldName: 'irr',
        fieldType: '100percentage2',
        tooltip: 'IRR of the fund’s investment in the portfolio company, as calculated by EE Invest Cap Table Waterfall; based on the investments of the fund in the portfolio company, the Realized Value and the NAV',
      },
    },
  },
  fundPortfolio: {
    label: 'Fund Portfolio',
    'components': {
      investedCapital: {
        label: 'Invested Capital',
        fieldName: 'investedCapital',
        fieldType: 'currency0',
        tooltip: '',
      },
      realizedValue: {
        label: 'Realized Value',
        fieldName: 'realizedValue',
        fieldType: 'currency0',
        tooltip: '',
      },
      FD: {
        label: 'FD%',
        fieldName: 'ownershipPercent',
        fieldType: 'percentage2',
        tooltip: 'The fund’s fully diluted ownership percentage of the portfolio company',
      },
      NAV: {
        label: 'NAV',
        fieldName: 'nav',
        fieldType: 'currency0',
        tooltip: 'NAV is determined by EE Invest based on the Waterfall output of the fund’s investment in the portfolio company; taking into account liquidation preferences, anti dilution provisions and similar investments and terms of co-investors',
      },
      EV: {
        label: 'EV',
        fieldName: 'ev',
        fieldType: 'currency0',
        tooltip: 'EV is determined by the PPS of the latest financing round multiplied by the # of fully diluted shares in the cap table',
      },
      multiple: {
        label: 'Multiple',
        fieldName: 'multiple',
        fieldType: 'ratio2',
        tooltip: 'NAV and Realized Value in the portfolio company, divided by the Invested Capital in the company',
      },
      IRR: {
        label: 'IRR',
        fieldName: 'irr',
        fieldType: '100percentage2',
        tooltip: 'IRR of the fund’s investment in the portfolio company, as calculated by EE Invest Cap Table Waterfall; based on the investments of the fund in the portfolio company, the Realized Value and the NAV',
      },
    },
  },
  clonedCaptables: {
    label: 'Cloned Captables',
    components: {},
  },
} as SettingsMap
